import { GetterTree } from 'vuex'
import { IRootState, IProductsState, IPlan } from '@/@types'

const getters: GetterTree<IProductsState, IRootState> = {
  plansByTerm: state => {
    return state.availablePlans.reduce(
      (
        acc: { yearly: Array<IPlan>; monthly: Array<IPlan>; quarterly: Array<IPlan> },
        plan: IPlan
      ) => {
        switch (plan.term) {
          case 'month':
            acc.monthly.push(plan)
            break
          case 'quarterly':
            acc.quarterly.push(plan)
            break
          default:
            acc.yearly.push(plan)
            break
        }
        return acc
      },
      { yearly: [], monthly: [], quarterly: [] }
    )
  },
  availableProductBundles: state => {
    return state.availableProductBundles
  },
  availableCertifications: state => {
    return state.availableCertifications
  },
  availablePlans: state => {
    return state.availablePlans
  },
  getPlanCodes: state => {
    return state.planCodes
  },
}

export default getters
